import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import CloseIcon from '@material-ui/icons/Close'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import { useStyles } from './Styles'
import { Slide, Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import Moment from 'react-moment'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const NotificationDetails = ({ isDialogOpen, DialogTitle, cancelDialog, selectedNotification, locale }) => {
  const classes = useStyles()

  return (
    <Dialog
      fullWidth
      maxWidth={"md"}
      onClose={cancelDialog}
      open={isDialogOpen}
      TransitionComponent={Transition}
      className={classes.DialogWrapper}
    >
      <MuiDialogTitle disableTypography>
        <Typography variant="h6" className={classes.dialogTitle}>{DialogTitle}</Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={cancelDialog}
          id='closeDialogButton'>
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>

      <div className={classes.notificationDetailsWrapper}>
        <div className={classes.RequestInfoWrapper}>
          <h2 className={classes.RequestHeading}>
            <FormattedMessage id={'NotificationsPageContent.ModalNotificationSectionTitle'} />
          </h2>
          <Grid container>
            <Grid item container xs={12} sm={6} md={6} className={classes.infoItemWrapper}>
              <Grid item xs={12} sm={6} className={classes.infoItemLabel}>
                <FormattedMessage id={'Fields.label.view.notificationId'} />
              </Grid>
              <Grid item xs={12} sm={6} className={classes.infoItemValue}>
                {selectedNotification.notificationId}
              </Grid>
            </Grid>
            <Grid item container xs={12} sm={6} md={6} className={classes.infoItemWrapper}>
              <Grid item xs={12} sm={6} className={classes.infoItemLabel}>
                <FormattedMessage id={'Fields.label.view.notificationType'} />
              </Grid>
              <Grid item xs={12} sm={6} className={classes.infoItemValue}>
                {selectedNotification.typeName}
              </Grid>
            </Grid>
            <Grid item container xs={12} sm={6} md={6} className={classes.infoItemWrapper}>
              <Grid item xs={12} sm={6} className={classes.infoItemLabel}>
                <FormattedMessage id={'Fields.label.view.notificationChannel'} />
              </Grid>
              <Grid item xs={12} sm={6} className={classes.infoItemValue}>
                {selectedNotification.channel}
              </Grid>
            </Grid>
            <Grid item container xs={12} sm={6} md={6} className={classes.infoItemWrapper}>
              <Grid item xs={12} sm={6} className={classes.infoItemLabel}>
                <FormattedMessage id={'Fields.label.view.notificationAddress'} />
              </Grid>
              <Grid item xs={12} sm={6} className={classes.infoItemValue}>
                {selectedNotification.address}
              </Grid>
            </Grid>
            <Grid item container xs={12} sm={6} md={6} className={classes.infoItemWrapper}>
              <Grid item xs={12} sm={6} className={classes.infoItemLabel}>
                <FormattedMessage id={'Fields.label.view.notificationLanguage'} />
              </Grid>
              <Grid item xs={12} sm={6} className={classes.infoItemValue}>
                <FormattedMessage id={`Notification.language.${selectedNotification.language?.toLowerCase()}`} />
              </Grid>
            </Grid>
            <Grid item container xs={12} sm={6} md={6} className={classes.infoItemWrapper}>
              <Grid item xs={12} sm={6} className={classes.infoItemLabel}>
                <FormattedMessage id={'Fields.label.view.notificationCreatedDateTime'} />
              </Grid>
              <Grid item xs={12} sm={6} className={classes.infoItemValue}>
                <Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{selectedNotification.creationDateTime}</Moment>
                <span> <Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format="hh:mm A">{selectedNotification.creationDateTime}</Moment></span>
              </Grid>
            </Grid>
            <Grid item container xs={12} sm={6} md={6} className={classes.infoItemWrapper}>
              <Grid item xs={12} sm={6} className={classes.infoItemLabel}>
                <FormattedMessage id={'Fields.label.view.notificationStatus'} />
              </Grid>
              <Grid item xs={12} sm={6} className={classes.infoItemValue}>
                <FormattedMessage id={`Notification.status.${selectedNotification.status}`} defaultMessage={selectedNotification.status} />
              </Grid>
            </Grid>


          </Grid>
        </div>
        <div className={classes.RequestInfoWrapper}>
          <h2 className={classes.RequestHeading}>
            <FormattedMessage id={'NotificationsPageContent.ModalDeliverySectionTitle'} />
          </h2>
          <Grid container>
            <Grid item container xs={12} sm={6} md={6} className={classes.infoItemWrapper}>
              <Grid item xs={12} sm={6} className={classes.infoItemLabel}>
                <FormattedMessage id={'Fields.label.view.notificationDeliveryType'} />
              </Grid>
              <Grid item xs={12} sm={6} className={classes.infoItemValue}>
              <FormattedMessage id={`Notification.status.${selectedNotification.deliveryType}`} />
              </Grid>
            </Grid>
            <Grid item container xs={12} sm={6} md={6} className={classes.infoItemWrapper}>
              <Grid item xs={12} sm={6} className={classes.infoItemLabel}>
                <FormattedMessage id={'Fields.label.view.notificationDeliveredDateTime'} />
              </Grid>
              <Grid item xs={12} sm={6} className={classes.infoItemValue}>
                <Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{selectedNotification.deliveredDateTime}</Moment>
                <span> <Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                  format="hh:mm A">{selectedNotification.deliveredDateTime}</Moment></span>
              </Grid>
            </Grid>
            <Grid item container xs={12} sm={6} md={6} className={classes.infoItemWrapper}>
              <Grid item xs={12} sm={6} className={classes.infoItemLabel}>
                <FormattedMessage id={'Fields.label.view.notificationNumberOfAttempts'} />
              </Grid>
              <Grid item xs={12} sm={6} className={classes.infoItemValue}>
                {selectedNotification.deliveryAttempts?.length || "0"}
              </Grid>
            </Grid>
          </Grid>
        </div>
        {!!selectedNotification?.messageBody &&
        <div className={classes.RequestInfoWrapper}>
          <h2 className={classes.RequestHeading}>
            <FormattedMessage id={'NotificationsPageContent.ModalMessageBodySectionTitle'}/>
          </h2>
          <div dangerouslySetInnerHTML={{ __html: selectedNotification.messageBody }}/>
        </div>}
      </div>
    </Dialog>
  )
}

export default NotificationDetails